import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "sectionTemplate", "hint"]
  static values = { index: Number }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, this.indexValue)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.indexValue++
    this.renumberSteps()
    this.toggleHint()
  }

  addSection(event) {
    event.preventDefault()
    if (!this.hasSectionTemplateTarget) return
    const html = this.sectionTemplateTarget.innerHTML.replace(/NEW_INDEX/g, this.indexValue)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.indexValue++
    this.updatePositions()
    this.toggleHint()
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-nested-fields-target='row']")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }

    this.renumberSteps()
    this.toggleHint()
  }

  // Reveal the "drag to reorder" hint once there are 2+ rows to reorder — so it
  // appears while building a recipe from scratch, not only after a reload.
  toggleHint() {
    if (!this.hasHintTarget) return
    const visible = [...this.containerTarget.querySelectorAll("[data-nested-fields-target='row']")]
      .filter((row) => row.style.display !== "none").length
    this.hintTarget.classList.toggle("hidden", visible < 2)
  }

  renumberSteps() {
    this.updatePositions()
    const steps = this.containerTarget.querySelectorAll("[data-step-number]")
    let visibleIndex = 1
    steps.forEach((el) => {
      const row = el.closest("[data-nested-fields-target='row']")
      if (row.style.display !== "none") {
        el.textContent = visibleIndex++
      }
    })
  }

  updatePositions() {
    const rows = this.containerTarget.querySelectorAll("[data-nested-fields-target='row']")
    let position = 0
    rows.forEach((row) => {
      if (row.style.display === "none") return
      const posInput = row.querySelector("input[name*='[position]']")
      if (posInput) posInput.value = position
      position++
    })
  }
}
